import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import { useForm } from "react-hook-form";
import { Badge, Form, Label, Spinner } from "reactstrap";
import Required from "../../../myComponents/validate/Required";
import Select from "react-select";
import ConfirmModal from "../../../myComponents/modals/ConfirmModal";
import MyDataTable from "../../../myComponents/DataTable/MyDataTable";
import { decrypt, encrypt } from "../../../utils/Encrypt";
import {
  createSubjectAPI,
  getClassDD,
  getStreamByClassDD,
  getSubjectAPI,
  updateSubjectAPI,
  updateSubjectStatusAPI,
} from "../../../api/LMS/master";
import { toast } from "react-toastify";
import { handleStatusChange, hasPermission } from "../../../utils/myFunctions";
import Status from "../../../myComponents/form/Status";
import MyButton from "../../../myComponents/form/MyButton";
import useLogout from "../../../hooks/useLogout";
import { useLocation, useNavigate } from "react-router";
import { optionList } from "../../../assets/constants/constants";

const Subject = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const enc = JSON.parse(localStorage.getItem("userDetail"));
  const user = decrypt(enc?.data || []);
  const isView = hasPermission(user, location?.pathname, "isView");
  const isUpdate = hasPermission(user, location?.pathname, "isUpdate");
  const isDelete = hasPermission(user, location?.pathname, "isDelete");
  const isCreate = hasPermission(user, location?.pathname, "isCreate");
  const [timer, setTimer] = useState(5); // 5 seconds countdown
  useEffect(() => {
    if (!isView) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      // redirect to home page when the timer reaches 0
      if (timer === 0) {
        navigate(-1);
      }
      // clean up the interval when the component unmounts
      return () => clearInterval(interval);
    } else {
      setIsLoading(false);
    }
  }, [timer]);
  const logout = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      status: null,
      streamList: [],
    },
  });
  const [data, setData] = useState([]);
  const [classList, setClassList] = useState([]);
  const [column, setColumn] = useState([
    {
      name: "Class",
      selector: (row) => row?.class_name,
      sortable: true,
    },
    {
      name: "Subject",
      selector: (row) => row?.subject_name_en + "(" + row?.subject_code + ")",
      sortable: true,
      wrap: true,
    },
    {
      name: "Subject name in Hindi",
      selector: (row) => row?.subject_name + "(" + row?.subject_code + ")",
      sortable: true,
      wrap: true,
    },
    {
      name: "Stream",
      selector: (row) => row?.stream,
      sortable: true,
      wrap: true,
    },
    {
      name: "Order",
      selector: (row) => row?.order,
      sortable: true,
    },
    {
      name: "Language",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }}>
          <Badge color={`${row?.isLanguage ? "info" : "primary"}`}>{row.isLanguage ? "Yes" : "No"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Compulsory",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }}>
          <Badge color={`${row?.isCompulsory ? "info" : "primary"}`}>{row.isCompulsory ? "Yes" : "No"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Optional",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }}>
          <Badge color={`${row?.isOptional ? "info" : "primary"}`}>{row.isOptional ? "Yes" : "No"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Additional",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }}>
          <Badge color={`${row?.isAdditional ? "info" : "primary"}`}>{row.isAdditional ? "Yes" : "No"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },

    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status == "active" ? "success" : "danger"}`}>
            {row.status == "active" ? "Active" : "Inactive"}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          {isUpdate && (
            <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
              {" "}
              <Icon name="edit" />
            </Button>
          )}
        </div>
      ),
    },
  ]);

  useEffect(() => {
    if(user?.role!="Subject Specialist"){

      getClass();
    }
    getSubject();
  }, []);

  const handleToggleStatus = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };

  const handleClassChange = (selectedOption) => {
    setValue("class", selectedOption || "");
    trigger("class");
    if (selectedOption?.value == "2" || selectedOption?.value == "3") {
      const data = {
        class_id: selectedOption?.value,
      };
      getStreamByClass(data);
    }
  };
  const getStreamByClass = (data) => {
    getStreamByClassDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setValue("streamList", res.data.data);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setValue("streamList", []);
        } else if (status == "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleStreamChange = (selectedOption) => {
    setValue("stream", selectedOption || "");
    trigger("stream");
  };
  const handleEdit = (row) => {
    // console.log("row", row);
    window.scrollTo(0, 0);
    setIsOpen(!isOpen);
    setMode("Edit");
    setValue("id", row.subject_id); // Add this for consistent `formData` structure
    setValue("subject", row.subject_name_en);
    setValue("subject_hn", row.subject_name);
    setValue("isLanguageSubject", row.isLanguage);
    setValue("isSubjectCompulsory", row.isCompulsory);
    setValue("isSubjectAdditional", row.isAdditional);
    setValue("isSubjectOptional", row.isOptional);
    setValue("isSubjectSports", row.isSports);
    setValue("subject_code", row.subject_code);
    setValue("order", row.order);
    setValue("stream", { value: row?.stream_id, label: row?.stream });
    setValue("status", {
      label: row.status == "active" ? "Active" : "Inactive",
      value: row.status == "active" ? "active" : "inactive",
    });
   setValue(
  "show_in_option",
  optionList.find((item) => item.value == row?.show_in_option)
);

    setValue("class", {
      label: row.class_name,
      value: row.class_id,
    });
    if (row?.class_id == 2) {
      const body = {
        class_id: "2",
      };
      setValue("stream", { value: row?.stream_id, label: row?.stream });
      getStreamByClass(body);
    }
    if (row?.class_id == 3) {
      const body = {
        class_id: "3",
      };
      setValue("stream", { value: row?.stream_id, label: row?.stream });
      getStreamByClass(body);
    }
  };
  const getClass = () => {
    const data = {};
    getClassDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setClassList(res.data.data);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setClassList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getSubject = () => {
    const data = {};
    setIsLoading(true);
    getSubjectAPI(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setData(res.data.data);
          setIsLoading(false);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.warning(res.data.message);
          setIsLoading(false);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const onFormSubmit = (data) => {
    const body = {
      ...(user?.role=="Subject Specialist"? {class_id: user?.class_id}:{class_id: watch("class")?.value}),
     
      subject_name_en: watch("subject"),
      subject_name: watch("subject_hn"),
      subject_code: watch("subject_code"),
      isLanguage: watch("isLanguageSubject")||false,
      isCompulsory: watch("isSubjectCompulsory")||false,
      isAdditional: watch("isSubjectAdditional")||false,
      isOptional: watch("isSubjectOptional")||false,
      isSubjectSports: watch("isSubjectSports")||false,
      order: watch("order"),
      status: watch("status")?.value,
      ...(user?.role=="Subject Specialist" ? {stream_id:user?.stream_id || null}:{stream_id: watch("stream")?.value || null}),
      show_in_option: watch("show_in_option")?.value||null,
      ...(mode == "Edit" && { id: watch("id") }),
    };
    console.log("khkjhkjh", body);
    if (mode == "Add") {
      createSubjectAPI(body)
        .then((res) => {
          // const status = decrypt(res.data.status);
          const status = res.data.status;
          if (status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getSubject();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === false) {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status == "expired") {
            console.log("response", res.data);
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          console.log("cat", err);

          setIsLoading(false);
          toast.error(err.message);
        });
    }
    if (mode == "Edit") {
      updateSubjectAPI(body)
        .then((res) => {
          // const status = decrypt(res.data.status);
          const status = res.data.status;
          if (status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getSubject();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === false) {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
  };
  const confirmStatusChange = () => {
    const updatedStatus = selectedRow.status === "Active" ? "Inactive" : "Active";

    const formObject = {
      id: selectedRow.subject_id,
      status: updatedStatus,
    };

    const encryptedData = encrypt(formObject);
    const encryptData = {
      zero: encryptedData,
    };
    updateSubjectAPI(formObject)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          getSubject();
          setShowModal(false);
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => console.error("Error updating status:", err));
  };
  const handleOptionChange=(opt)=>{
    setValue("show_in_option", opt||"");
    trigger("show_in_option");
  }
  return (
    <>
      <Head title="Subject | Master" />
      <Content>
        {!isView ? (
          <div className="p-5" style={{}}>
            <p style={{ color: "crimson", textAlign: "center" }}>{"Unauthorized"}</p>
            <p style={{ textAlign: "center" }}>
              You will be redirected to the home page in <b style={{ color: "crimson" }}>{timer} </b> seconds.
            </p>
          </div>
        ) : (
          <>
            <BlockHead size={`sm`}>
              <BlockBetween>
                <BlockHeadContent>
                  <BlockTitle page tag="h3">
                    {"Subject"}
                  </BlockTitle>
                </BlockHeadContent>
                {isCreate && (
                  <BlockHeadContent>
                    <div className="">
                      <Button
                        color="primary"
                        outline
                        className={`  me-n1`}
                        onClick={() => {
                          setIsOpen(!isOpen);
                          setMode("Add");
                          reset();
                        }}
                      >
                        {<Icon name={isOpen ? "minus" : "plus"} />}
                      </Button>
                    </div>
                  </BlockHeadContent>
                )}
              </BlockBetween>
            </BlockHead>
            <Block>
              <Row className={`g-gs`}>
                {isOpen && (
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row className={`g-gs`}>
                        {/* Class */}
                      {user?.role=="Subject Specialist" ? null:  <Col md={`2`}>
                          <div className="form-group">
                            <Label className="from-label" htmlFor="class">
                              Class
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <Select
                                className=""
                                id="class"
                                options={classList}
                                {...register("class", {
                                  required: "Please select class",
                                })}
                                onChange={handleClassChange}
                                value={watch("class")}
                              />
                              {errors.class && <span className="invalid">{errors?.class?.message}</span>}
                            </div>
                          </div>
                        </Col>}
                        {/* Stream */}
                     {user?.role=="Subject Specialist" ? null :<>
                        {(watch("class")?.value == "2" || watch("class")?.value == "3") && (
                          <Col md={`2`}>
                            <div className="form-group">
                              <Label className="from-label" htmlFor="stream">
                                Stream
                                <Required />
                              </Label>
                              <div className="form-control-wrap">
                                <Select
                                  className=""
                                  id="stream"
                                  options={watch("streamList")}
                                  {...register("stream", {
                                    required: "Please select stream",
                                  })}
                                  onChange={handleStreamChange}
                                  value={watch("stream")}
                                />
                                {errors.stream && (
                                  <span
                                    className="invalid"
                                    style={{
                                      color: "#e85347",
                                      fontSize: "11px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {errors?.stream?.message}
                                  </span>
                                )}
                              </div>
                            </div>
                          </Col>
                        )}</>}
                         {/*Subject Code */}
                            <Col md="4" sm="3" xxl="2">
                              <div className="form-group">
                                <Label className="form-label" htmlFor="subject_code">
                                  {"Subject Code"}
                                  <Required />
                                </Label>
                                <div className="form-control-wrap">
                                  <input
                                    placeholder={"Enter subject code name"}
                                    type="text"
                                    id="subject_code"
                                    {...register("subject_code", {
                                      required: {
                                        value: true,
                                        message: "Subject code is required",
                                      },
                                      pattern: {
                                        value: /^\d{1,10}$/,
                                        message: "Only digits are allowed (no letters, spaces, or symbols).",
                                      },
                                      minLength: {
                                        value: 3,
                                        message: "Subject code must be at least 2 characters long",
                                      },
                                      maxLength: {
                                        value: 50,
                                        message: "Subject code cannot exceed 50 characters",
                                      },
                                    })}
                                    className="form-control"
                                    value={watch("subject_code")}
                                    onChange={(e) => {
                                      // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                                      // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                      setValue("subject_code", e.target.value);
                                      trigger("subject_code"); // Trigger validation
                                    }}
                                    // onInput={(e) => {
                                    //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                                    // }}
                                  />
                                  {errors.subject_code && (
                                    <span className="invalid">{errors?.subject_code?.message}</span>
                                  )}
                                </div>
                              </div>
                            </Col>{" "}
                        {watch("class")?.value == "1" || watch("class")?.value == 4 ? (
                          <>
                           <Col md={`2`}>
                            <div className="form-group">
                              <Label className="from-label" htmlFor="show_in_option">
                                Select Subject View In Option
                                <Required />
                              </Label>
                              <div className="form-control-wrap">
                                <Select
                                  className=""
                                  id="show_in_option"
                                  options={optionList}
                                  {...register("show_in_option", {
                                    required: "Please select show in which option",
                                  })}
                                  onChange={handleOptionChange}
                                  value={watch("show_in_option")}
                                />
                                {errors.show_in_option && (
                                  <span
                                    className="invalid"
                                    style={{
                                      color: "#e85347",
                                      fontSize: "11px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {errors?.show_in_option?.message}
                                  </span>
                                )}
                              </div>
                            </div>
                          </Col>
                          </>
                        ) : (
                          <>
                            {" "}
                           
                            <Col xxl={watch("class")?.value == "1" ? "2" : "1"}>
                              <div className="">
                                <span className="preview-title overline-title">Language</span>
                                <div className="g-3 align-center">
                                  <div className="g">
                                    <div className="custom-control custom-control-sm custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="isLanguageSubject"
                                        {...register("isLanguageSubject")}
                                        disabled={
                                          watch("isSubjectCompulsory") ||
                                          watch("isSubjectOptional") ||
                                          watch("isSubjectAdditional") ||
                                          watch("isSubjectSports")
                                        }
                                      />
                                      <label className="custom-control-label" htmlFor="isLanguageSubject">
                                        Is Language Subject
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col xxl={watch("class")?.value == "1" ? "2" : "1"}>
                              <div className="">
                                <span className="preview-title overline-title">Compulsory</span>
                                <div className="g-3 align-center">
                                  <div className="g">
                                    <div className="custom-control custom-control-sm custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="isSubjectCompulsory"
                                        {...register("isSubjectCompulsory")}
                                        disabled={
                                          watch("isLanguageSubject") ||
                                          watch("isSubjectOptional") ||
                                          watch("isSubjectAdditional") ||
                                          watch("isSubjectSports")
                                        }
                                      />
                                      <label className="custom-control-label" htmlFor="isSubjectCompulsory">
                                        Is Subject Compulsory
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col xxl={watch("class")?.value == "1" ? "2" : "1"}>
                              <div className="">
                                <span className="preview-title overline-title">Optional</span>
                                <div className="g-3 align-center">
                                  <div className="g">
                                    <div className="custom-control custom-control-sm custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="isSubjectOptional"
                                        {...register("isSubjectOptional")}
                                        disabled={
                                          watch("isLanguageSubject") ||
                                          watch("isSubjectCompulsory") ||
                                          watch("isSubjectAdditional") ||
                                          watch("isSubjectSports")
                                        }
                                      />
                                      <label className="custom-control-label" htmlFor="isSubjectOptional">
                                        Is Subject Optional
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col xxl={watch("class")?.value == "1" ? "2" : "1"}>
                              <div className="">
                                <span className="preview-title overline-title">Additional</span>
                                <div className="g-3 align-center">
                                  <div className="g">
                                    <div className="custom-control custom-control-sm custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="isSubjectAdditional"
                                        {...register("isSubjectAdditional")}
                                        disabled={
                                          watch("isLanguageSubject") ||
                                          watch("isSubjectCompulsory") ||
                                          watch("isSubjectOptional") ||
                                          watch("isSubjectSports")
                                        }
                                      />
                                      <label className="custom-control-label" htmlFor="isSubjectAdditional">
                                        Is Subject Additional
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col xxl={watch("class")?.value == "1" ? "2" : "1"}>
                              <div className="">
                                <span className="preview-title overline-title">Sports</span>
                                <div className="g-3 align-center">
                                  <div className="g">
                                    <div className="custom-control custom-control-sm custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="isSubjectSports"
                                        {...register("isSubjectSports")}
                                        disabled={
                                          watch("isLanguageSubject") ||
                                          watch("isSubjectCompulsory") ||
                                          watch("isSubjectOptional") ||
                                          watch("isSubjectAdditional")
                                        }
                                      />
                                      <label className="custom-control-label" htmlFor="isSubjectSports">
                                        Is Sports Subject
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </>
                        )}
                        {/* Subject Order */}
                        <Col md="2" sm="3" xxl="2">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="order">
                              {"Order"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <input
                                placeholder={"Enter order"}
                                type="text"
                                id="order"
                                {...register("order", {
                                  required: "Order is required",
                                  pattern: {
                                    value: /^[1-9][0-9]{0,2}$/,
                                    message: "Enter a Order greater than 0 and up to 100",
                                  },
                                  minLength: {
                                    value: 1,
                                    message: "Order must be at least 1 character long",
                                  },
                                  validate: (value) =>
                                    (value >= 1 && value <= 100) || "Order must be between 1 and 100",
                                })}
                                className="form-control"
                                onChange={(e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                  setValue("order", e.target.value);
                                  trigger("order"); // Trigger validation
                                }}
                                value={watch("order")}
                              />
                              {errors.order && <span className="invalid">{errors?.order?.message}</span>}
                            </div>
                          </div>
                        </Col>{" "}
                        {/* Status */}
                        <Col md="2" sm="3" xxl={"2"}>
                          <Status
                            setValue={setValue}
                            trigger={trigger}
                            register={register}
                            watch={watch}
                            errors={errors}
                          />
                        </Col>
                        {/*Subject Name */}
                        <Col
                          md="4"
                          sm="3"
                          xxl={watch("class")?.value == "2" || watch("class")?.value == "3" ? "5" : "4"}
                        >
                          <div className="form-group">
                            <Label className="form-label" htmlFor="subject">
                              {"Subject Name"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <input
                                placeholder={"Enter subject name"}
                                type="text"
                                id="subject"
                                {...register("subject", {
                                  required: {
                                    value: true,
                                    message: "Subject name is required",
                                  },
                                  pattern: {
                                    value: /^(?!\s*$)[a-zA-Z /.]*$/,
                                    message: "Please enter the subject name in English only.",
                                  },
                                  minLength: {
                                    value: 3,
                                    message: "Subject name must be at least 2 characters long",
                                  },
                                  maxLength: {
                                    value: 50,
                                    message: "Subject name cannot exceed 50 characters",
                                  },
                                })}
                                className="form-control"
                                value={watch("subject")}
                                onChange={(e) => {
                                  // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                                  // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                  setValue("subject", e.target.value);
                                  trigger("subject"); // Trigger validation
                                }}
                                // onInput={(e) => {
                                //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                                // }}
                              />
                              {errors.subject && <span className="invalid">{errors?.subject?.message}</span>}
                            </div>
                          </div>
                        </Col>{" "}
                        {/*Subject Name Hindi */}
                        <Col
                          md="4"
                          sm="3"
                          xxl={watch("class")?.value == "2" || watch("class")?.value == "3" ? "5" : "4"}
                        >
                          <div className="form-group">
                            <Label className="form-label" htmlFor="subject_hn">
                              {"Subject Name in Hindi"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <input
                                placeholder={"Enter subject name in hindi"}
                                type="text"
                                id="subject_hn"
                                {...register("subject_hn", {
                                  required: {
                                    value: true,
                                    message: "Subject name in hindi is required",
                                  },
                                  pattern: {
                                    value: /^[‌\u0900-\u097F\s]+$/,
                                    message: "Please write the subject name only in Hindi.",
                                  },
                                  minLength: {
                                    value: 3,
                                    message: "Subject name in hindi must be at least 2 characters long",
                                  },
                                  maxLength: {
                                    value: 50,
                                    message: "Subject name in hindi cannot exceed 50 characters",
                                  },
                                })}
                                className="form-control"
                                value={watch("subject_hn")}
                                onChange={(e) => {
                                  // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                                  // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                  setValue("subject_hn", e.target.value);
                                  trigger("subject_hn"); // Trigger validation
                                }}
                                // onInput={(e) => {
                                //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                                // }}
                              />
                              {errors.subject_hn && <span className="invalid">{errors?.subject_hn?.message}</span>}
                            </div>
                          </div>
                        </Col>{" "}
                      </Row>
                      <Col md="2" className={``}>
                        <MyButton isLoading={isLoading} mode={mode} />
                      </Col>
                    </Form>
                  </PreviewAltCard>
                )}
                <MyDataTable data={data} columns={column} title={"Subject"} isLoading={isLoading} />
              </Row>
            </Block>
          </>
        )}
      </Content>

      {/* Confirmation Modal */}
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={selectedRow?.status}
      />
    </>
  );
};

export default Subject;
